import { getMaxPerDay } from '~/pages/Marketing/AppOnlyFlash/appOnlyFlashCalendar';

import { APP_EXCLUSIVE_MAX_PER_DAY } from '~/consts/appExclusive';

import { useGetEligibleAppExclusiveOffers } from './useGetEligibleAppExclusiveOffers';

// Only the response's `maxPerDay` is needed, not the offer list.
const LIMIT_LOOKUP_OFFERS = 1;

/**
 * Most App Only Flash deals one region can hold per day, from svc-offer's eligible lookup on `date`, so the
 * calendar uses the same limit as the Add, Move and Copy dialogs (1 on older svc-offer). Falls back to
 * APP_EXCLUSIVE_MAX_PER_DAY while loading or if the lookup fails; the dialogs still check svc-offer.
 */
export function useGetAppExclusiveMaxPerDay(region: string, date: string): number {
  const { data } = useGetEligibleAppExclusiveOffers({ region, date, limit: LIMIT_LOOKUP_OFFERS });
  return data ? getMaxPerDay(data) : APP_EXCLUSIVE_MAX_PER_DAY;
}
